/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_System_Prompt_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Describe the task, the steps to follow and how the result should look." |
*
* @param {Agent_Builder_System_Prompt_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_system_prompt_placeholder = /** @type {((inputs?: Agent_Builder_System_Prompt_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_System_Prompt_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreiben Sie die Aufgabe, die einzelnen Schritte und wie das Ergebnis aussehen soll.")
	return /** @type {LocalizedString} */ ("Describe the task, the steps to follow and how the result should look.")
});